export const ALLOWED_DIRECTIVES = new Set([
	'note',
	'info',
	'tip',
	'warning',
] as const);

export type DirectiveTone = 'note' | 'info' | 'tip' | 'warning';

export const GITHUB_ALERT_TO_TONE: Record<string, DirectiveTone> = {
	NOTE: 'note',
	TIP: 'tip',
	IMPORTANT: 'info',
	WARNING: 'warning',
	CAUTION: 'warning',
};

export const LANG_LABELS: Record<string, string> = {
	js: 'JavaScript',
	javascript: 'JavaScript',
	ts: 'TypeScript',
	typescript: 'TypeScript',
	jsx: 'JSX',
	tsx: 'TSX',
	py: 'Python',
	python: 'Python',
	java: 'Java',
	kotlin: 'Kotlin',
	swift: 'Swift',
	go: 'Go',
	rs: 'Rust',
	rust: 'Rust',
	cpp: 'C++',
	'c++': 'C++',
	cs: 'C#',
	csharp: 'C#',
	sql: 'SQL',
	sh: 'Shell',
	bash: 'Bash',
	zsh: 'Zsh',
	json: 'JSON',
	yaml: 'YAML',
	yml: 'YAML',
	css: 'CSS',
	html: 'HTML',
	xml: 'XML',
	md: 'Markdown',
	markdown: 'Markdown',
};

export const LANG_ALIASES: Record<string, string> = {
	js: 'javascript',
	ts: 'typescript',
	py: 'python',
	rs: 'rust',
	'c++': 'cpp',
	cs: 'csharp',
	sh: 'bash',
	zsh: 'bash',
	yml: 'yaml',
	md: 'markdown',
};

export function langLabel(langId: string | null): string | null {
	if (!langId) return null;
	const lower = langId.toLowerCase();
	return LANG_LABELS[lower] ?? lower.charAt(0).toUpperCase() + lower.slice(1);
}
